import { render, staticRenderFns } from "./ImageClassification.vue?vue&type=template&id=30dfa098&scoped=true"
import script from "./ImageClassification.vue?vue&type=script&lang=js"
export * from "./ImageClassification.vue?vue&type=script&lang=js"
import style0 from "./ImageClassification.vue?vue&type=style&index=0&id=30dfa098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dfa098",
  null
  
)

export default component.exports